import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GaugingElement } from '@app/platform/busines-data/SectionElements/InspectionElements/gaugingElement';

export interface InspectionEvent {
  type: 'save' | 'delete' | 'load';
  elements: GaugingElement[];
  timestamp: Date;
}

@Injectable({
  providedIn: 'root'
})
export class InspectionEventsService {
  private inspectionEventsSubject = new BehaviorSubject<InspectionEvent | null>(null);
  
  public inspectionEvents$: Observable<InspectionEvent | null> = this.inspectionEventsSubject.asObservable();

  emitSaveEvent(elements: GaugingElement[]): void {
    const event: InspectionEvent = {
      type: 'save',
      elements: elements,
      timestamp: new Date()
    };
    this.inspectionEventsSubject.next(event);
  }

  emitDeleteEvent(elements: GaugingElement[]): void {
    const event: InspectionEvent = {
      type: 'delete',
      elements: elements,
      timestamp: new Date()
    };
    this.inspectionEventsSubject.next(event);
  }

  emitLoadEvent(elements: GaugingElement[]): void {
    const event: InspectionEvent = {
      type: 'load',
      elements: elements,
      timestamp: new Date()
    };
    this.inspectionEventsSubject.next(event);
  }

  getCurrentEvent(): InspectionEvent | null {
    return this.inspectionEventsSubject.value;
  }
} 